import React, { useEffect, useMemo, useState } from 'react';
import { API_URL, ENDPOINTS } from '../../../helpers/constants';

export default function CourseImageThumb({ courseId, raw, alt, height, width, layout = 'default' }) {
  const src = useMemo(() => {
    const v = raw == null ? '' : String(raw).trim();
    if (!v) return null;
    if (/^https?:\/\//i.test(v) || v.startsWith('data:') || v.startsWith('/')) {
      return v;
    }
    if (/^[a-fA-F0-9]{24}$/.test(v) && courseId) {
      return `${API_URL}${ENDPOINTS.COURSE_ATTACHMENT_STREAM(courseId, v)}`;
    }
    return v;
  }, [courseId, raw]);

  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src) return null;

  const isHero = layout === 'hero';
  const isInline = layout === 'inline';

  const wrapperStyle = {
    overflow: 'hidden',
    boxSizing: 'border-box',
    border: isHero ? 'none' : '1px solid #dee2e6',
    borderRadius: isHero ? '0.25rem 0.25rem 0 0' : isInline ? '0.5rem' : '0.75rem',
    width: isHero ? '100%' : width != null ? width : undefined,
    maxWidth: width != null ? width : undefined,
    flexShrink: width != null ? 0 : undefined
  };

  if (failed) {
    return (
      <div
        style={{
          ...wrapperStyle,
          height,
          backgroundColor: '#e9ecef',
          color: '#6c757d',
          fontSize: '0.875rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0 0.25rem'
        }}
      >
        Preview unavailable
      </div>
    );
  }

  return (
    <div style={wrapperStyle}>
      <img
        src={src}
        alt={alt}
        loading={isHero ? 'eager' : 'lazy'}
        decoding="async"
        onError={() => setFailed(true)}
        style={{ display: 'block', width: '100%', height, objectFit: 'cover' }}
      />
    </div>
  );
}
